export default __webpack_public_path__ + "static/shallote-a8cb014ca7c5b62318dc0f15c97a2313.webp";